/*
 * GEHC CONFIDENTIAL
 *
 * Copyright (c) 2025, 2025, GE HealthCare
 * All Rights Reserved
 *
 * This unpublished material is proprietary to GE HealthCare. The methods and
 * techniques described herein are considered trade secrets and/or
 * confidential. Reproduction or distribution, in whole or in part, is
 * forbidden except by express written permission of GE HealthCare.
 * GE is a trademark of General Electric Company used under trademark license.
 */
import { Logger } from '@core/lib/services';
import { Injectable, Injector } from '@angular/core';
import { DiConfigService } from '@app/di/di-config.service';

import { UniversalViewerService } from '@app/di/integrations/viewer/uv/universal-viewer.service';
import { AppLauncherService } from '@app/di/integrations/app-launcher.service';
import { UniversalViewerContextService } from '@app/di/integrations/viewer/uv/universal-viewer-context.service';
import { EnterpriseViewerService } from './ev/enterprise-viewer.service';

const log = new Logger('ViewerIntegrationService');

@Injectable({
  providedIn: 'root'
})
export class ViewerIntegrationService {
  private viewerService;
  private uvContextService: UniversalViewerContextService;
  private appLauncherService: AppLauncherService;

  public get viewer() {
    return this.viewerService;
  }
  constructor(private readonly injector: Injector, private readonly diConfigService: DiConfigService) {}

  initialize() {
    log.info('ViewerIntegration Initializing...');
    this.setViewerService();
  }

  private setViewerService() {
    if (this.diConfigService.integrationConfig?.Ev) {
      this.viewerService = this.injector.get(EnterpriseViewerService);
      this.viewerService.init();
    } else {
      this.appLauncherService = this.injector.get(AppLauncherService);
      this.appLauncherService.init();

      this.uvContextService = this.injector.get(UniversalViewerContextService);
      this.uvContextService.initialize();

      this.viewerService = this.injector.get(UniversalViewerService);
      this.viewerService.init();
    }
  }

  // Utility functions
  checkViewerExistAndClosable(contextId) {
    return this.viewerService?.checkViewerExistAndClosable?.(contextId);
  }
  closeViewer(actionName, contextId) {
    return this.viewerService?.closeViewer?.(actionName, contextId);
  }
  hideAllOpenViewers() {
    return this.viewerService?.hideAllOpenViewers?.();
  }
  checkViewerVisibleForStudy(contextId) {
    return this.viewerService?.checkViewerVisibleForStudy?.(contextId);
  }
  handleCloseExamRequest(contextId) {
    return this.viewerService?.handleCloseExamRequest?.(contextId);
  }
}
